var _rect, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMasterCardLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 29,
    viewBox: "0 0 44 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.52832,
    y: 0.965088,
    width: 43.4717,
    height: 28,
    fill: "url(#masterCardLogo)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "masterCardLogo",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_8304_19042",
    transform: "matrix(0.0126294 0 0 0.0196078 -0.00517473 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_8304_19042",
    width: 80,
    height: 51,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAAAzCAYAAAAAcY9ZAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABFpJREFUeNrsm91OE0EUx2d3Wz+QhBUkMYLaiyZG40WJXgsk3luuvKR9gtInkD4B7RO0PIHtE1DuTeyVVyQuBBMTxCwJ0UC7u85ZZ3FZ9rM7O6cYTjJpSrqd6W/+52OXM4TcWCqTsvzy48Xiis+ftbnDPS3Lec/aC37zDm5Xv+kTC5DCKtCXMh3LdJToKERcMmBjl44uhaqPCavkmVeNuKTP5u1RoH1UgBQaLLZCxzpbfBrr0tGiIPsxoMHm1Bi4Qoo5YdM6MC+FqQkDyMBtsB+hcvYKANjwA8nAfWCbxtsAZCMpSGkMeLDrWyl3Pq4i6068pPA2M9owrwHETe4Ameq2Mtr9QBfLvTTqd96f1ziEiCQGMbJKQQ64AGTwdgT/CCKpFsm/MYny2CDKQ0N0haIziN1UALHhkfzf9/KsSXJPRhilHkDsjAVwUuA5NokQpesCzzEACCAR3HnVLybKIRdtiYYH0HKvrEB4YKODHLFOZdEAQUwfaSWgxgLISpWK6FUqL0xbgVE2OlAIEZ5T7LKtHQnQVa4INXneIkrRivVZ61wixncFIxaWvffZfgrcEFAkX1XfcyvR540jxQaJYO1AgEx9NQz1SfNW4uuQVFigKqwEKbAi4FYptfocM3/KWCqsBQEUrj5pioylvguIJzIGwBJ7jPYPIHXfOM/w+LvvIyvV9aBCJFv3KrCMsYq0AK3fEpYbl70AlzFWkcZ9LyCeogCEZFJwA1zByL48DFSIZCWZxb8CyvRThBNAGRcgRvKw3fceJ4DnWPzIDNrW8TSkJIKvQPmBde03zwGokhtLBXCAMbn5Q/pvAF5vU9Bm1hyAOsr0nLKnfBctlu7bAOcO91Bc2Drh9EW3LHQFosRBU+cTAyU8BQ7cAPvCpx9SFXKAKE+bGPB0+C+dG+AuTiZOqT7qvkgK7F7KwjQOdjGSibmfToHyjInlvj2/MqYjPJFQF7Z+pQA4iwJQc3pmvABbGKsxvoxXjsrTaO677VtIs168DoYbj6NChI4tp2Zuht2JNDBiYVIV2urDyb4Nd7P6lVUzFbZQVHgUM6HQWzcFp0sLOv2bl6qAoE8eLxY/E9GdWVOE5N8aoc1FNr8FgyjzKA2Xq+wVutZUCvN+mN+siXZliIOjT3Jk1kWAB1aHwpk1oa+xEdlgWXJoi1yp/NQiudem7y1b/tkQA16Tgqv7ek3UlZMC0YZXHGI8uupQeNXAdUZdzZ7UrIp2Z0gqjjtDxkWC1wyDFwugC+KS6Cc2ANHUSCdXHOqC4Tkd+vVIT4n7jVDe0LHkLiKzvl0C5c/0vlbZ5vUFzQvzLIV15ieKgSFxEbpYVzLafahDm94DiGfthSxPSWmsSE50J5b2sCEAdA798fgB237gvMYaHHmdXoKw1EoKjgtAF0iVQXzHVKkmgAYu02OP0xIZO3wIMJcTesOAzbsd5zhX5gB9gBaYm/md39XYGIx7RjgEqLN5pQBoOo8zwm77I8AALWCRnSrPsKgAAAAASUVORK5CYII="
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCardLogo);
export default __webpack_public_path__ + "static/media/master-card-logo.a4f6544a1bd6b89d41b85aa6b3832cd1.svg";
export { ForwardRef as ReactComponent };